import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import _ from "lodash"

class DragManager {
    constructor(data) {
        gsap.registerPlugin(Draggable);
        this.dragMap = new Map();
        this.dropMap = new Map();
    }

    registerDrops(drops) {
        _.map(drops, (d, i) => {
            this.dropMap.set(d.id, {"id": d.id, "target": d})
        })
    }

    resetDrag(id){
        let dragProxy = this.dragMap.get(id);
        if(dragProxy.drop && dragProxy.drop.drag)
        {
            dragProxy.drop.drag = null;
        }
        dragProxy.drop = null;
        gsap.to(dragProxy.target, {x: dragProxy.startX, y: dragProxy.startY})
    }

    initDrags(dragClassName) {
        var drags = document.querySelectorAll(dragClassName);
        _.map(drags, (d, i) => {
            let drag = Draggable.create("#" + d.id, {type: "x,y"}, [0])
            this.dragMap.set(d.id, {"id": d.id, "draggable": drag, "target": drag[0].target, "startX": drag[0].x, "startY": drag[0].y})
            drag[0].addEventListener("dragstart", this.onDragStart);
            drag[0].addEventListener("dragend", this.onDragEnd);
            drag[0].ref = this;
        })
    }

    getState(){
        let drops = [];
        this.dropMap.forEach((dropProxy) => {
            drops.push(dropProxy);
            //console.log("DragManager state:")
            //console.log("       drop"+dropProxy.id+": drag - "+(dropProxy.drag?dropProxy.drag.id:"null"))
        });
        return drops
    }

    disableDrag(id){
        var drag = this.dragMap.get(id);
        drag.draggable[0].disable()
    }

    disableDrop(id){
        var dropProxy = this.dropMap.get(id);
        dropProxy.disabled = true;
    }

    onPress() {
        //console.log("onPress: " + this.target);
    }

    onDragStart() {
        let dragProxy = this.ref.dragMap.get(this.target.id);
        if(dragProxy.drop){
            dragProxy.drop.drag = null;
        }
        dragProxy.drop = null;
    }

    checkHit(drag) {
        console.log("checkHit(" + drag + ")")
        let hitTarget = null
        let hitProxy = null
        let dragProxy = this.dragMap.get(drag.target.id)
        this.dropMap.forEach((dropProxy) => {
            if (drag.hitTest(dropProxy.target, "50%")&&!hitTarget&&!dropProxy.disabled) {
                hitTarget = dropProxy.target;
                hitProxy = dropProxy;
            }
        });
        if (hitTarget) {
            gsap.to(drag.target, {
                duration: 0.2,
                x: hitTarget.offsetLeft - drag.target.offsetLeft,
                y: hitTarget.offsetTop - drag.target.offsetTop
            });
            if(hitProxy.drag)
            {
                gsap.to(hitProxy.drag.target, {x: hitProxy.drag.startX, y: hitProxy.drag.startY})
                hitProxy.drag.drop = null;
                hitProxy.drag = null;
            }
            hitProxy.drag = dragProxy;
            dragProxy.drop = hitProxy;

        } else {
            dragProxy.drop = null;
            gsap.to(dragProxy.target, {x: dragProxy.startX, y: dragProxy.startY})
        }
        this.getState();
    }

    onDragEnd() {
        this.ref.checkHit(this);
    }


}

export default DragManager;